import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { NavLink, Link } from "react-router-dom";
import API_BASE_URL from "../config/api";
import "./Navbar.css";

function Navbar() {
const [menuOpen, setMenuOpen] = useState(false);

const [searchOpen, setSearchOpen] = useState(false);
const [searchQuery, setSearchQuery] = useState("");
const [searchResults, setSearchResults] = useState([]);

const navigate = useNavigate();
const { cartCount } = useCart();

  const closeMenu = () => {
    setMenuOpen(false);
  };
useEffect(() => {
  const searchProducts = async () => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }

    try {
      const response = await fetch(
         `${API_BASE_URL}/api/products`
      );

      const data = await response.json();

      if (data.success && Array.isArray(data.products)) {
        const query = searchQuery.toLowerCase().trim();

        const filteredProducts = data.products.filter((product) =>
          product.name?.toLowerCase().includes(query)
        );

        setSearchResults(filteredProducts);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    }
  };

  const timer = setTimeout(searchProducts, 250);

  return () => clearTimeout(timer);
}, [searchQuery]);

  const toggleMenu = () => {
    setMenuOpen((previousState) => !previousState);
  };

  return (
    <header className="tv-navbar">

      <div className="tv-navbar-container">

        {/* Logo */}

        <Link
          to="/"
          className="tv-navbar-logo"
          onClick={closeMenu}
        >
          <img
            src="/images/logo.png"
            alt="Time Valley"
          />
        </Link>

<span className="tv-navbar-mobile-brand">
  <span className="tv-brand-time">TIME</span>
  <span className="tv-brand-valley">VALLEY</span>
</span>
        {/* Desktop Navigation */}

        <nav
          className={`tv-navbar-menu ${
            menuOpen ? "tv-navbar-menu-active" : ""
          }`}
        >

          <div className="tv-navbar-menu-top">
            <span className="tv-navbar-menu-title">
              TIME VALLEY
            </span>

            <button
              type="button"
              className="tv-navbar-close"
              onClick={closeMenu}
              aria-label="Close navigation menu"
            >
              <span></span>
              <span></span>
            </button>
          </div>


         <div className="tv-navbar-menu-links">

  <NavLink
    to="/"
    end
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    Home
  </NavLink>

  <NavLink
    to="/shop"
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    Shop
  </NavLink>

  {/* <NavLink
    to="/men"
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    Men
  </NavLink> */}

  <NavLink
    to="/collections"
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    Collections
  </NavLink>

  <NavLink
    to="/about"
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    About
  </NavLink>

  <NavLink
    to="/contact"
    onClick={closeMenu}
    className={({ isActive }) =>
      isActive ? "tv-navbar-link-active" : ""
    }
  >
    Contact
  </NavLink>

</div>

        </nav>


        {/* Mobile Overlay */}

        <div
          className={`tv-navbar-overlay ${
            menuOpen ? "tv-navbar-overlay-active" : ""
          }`}
          onClick={closeMenu}
          aria-hidden="true"
        ></div>


        {/* Right Side Actions */}

        <div className="tv-navbar-actions">

          {/* Search */}

       <button 
  type="button" 
  className="tv-navbar-action" 
  aria-label="Search"
  onClick={() => {
    setSearchOpen((previousState) => !previousState);
    setSearchQuery("");
    setSearchResults([]);
  }}
>
            <svg
              className="tv-navbar-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle
                cx="11"
                cy="11"
                r="6.5"
              />

              <path d="M16 16L21 21" />
            </svg>
          </button>


          {/* Wishlist */}

          <button
            type="button"
            className="tv-navbar-action tv-navbar-wishlist"
            aria-label="Wishlist"
          >
            <svg
              className="tv-navbar-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M20.8 8.7c0 5.4-8.8 10.2-8.8 10.2S3.2 14.1 3.2 8.7A4.7 4.7 0 0 1 8 4a5.1 5.1 0 0 1 4 2.1A5.1 5.1 0 0 1 16 4a4.7 4.7 0 0 1 4.8 4.7Z" />
            </svg>
          </button>


          {/* Cart */}

          <button
  type="button"
  className="tv-navbar-action tv-navbar-cart"
  aria-label="Shopping cart"
  onClick={() => navigate("/cart")}
>
  <svg
    className="tv-navbar-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M3 4h2l2.1 10.2a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.5L20.5 8H6" />

    <circle
      cx="9"
      cy="19"
      r="1.5"
    />

    <circle
      cx="17"
      cy="19"
      r="1.5"
    />
  </svg>

  <span className="tv-navbar-cart-count">
    {cartCount}
  </span>
</button>


          {/* Mobile Menu Button */}

          <button
            type="button"
            className={`tv-navbar-toggle ${
              menuOpen ? "tv-navbar-toggle-active" : ""
            }`}
            onClick={toggleMenu}
            aria-label={
              menuOpen
                ? "Close navigation menu"
                : "Open navigation menu"
            }
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
{searchOpen && (
  <div className="tv-navbar-search-box">

    <div className="tv-navbar-search-input-wrap">

      <svg
        className="tv-navbar-search-input-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          cx="11"
          cy="11"
          r="6.5"
        />

        <path d="M16 16L21 21" />
      </svg>

      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search watches..."
        autoFocus
      />

      <button
        type="button"
        className="tv-navbar-search-close"
        onClick={() => {
          setSearchOpen(false);
          setSearchQuery("");
          setSearchResults([]);
        }}
        aria-label="Close search"
      >
        ×
      </button>

    </div>


    {searchQuery.trim() && (
      <div className="tv-navbar-search-results">

        {searchResults.length > 0 ? (
          searchResults.map((product) => (
            <button
              type="button"
              className="tv-navbar-search-result"
              key={product.id}
              onClick={() => {
                setSearchOpen(false);
                setSearchQuery("");
                setSearchResults([]);

                navigate(`/product/${product.id}`);
              }}
            >

              <img
               src={
  product.image1?.startsWith("http")
    ? product.image1
    : `${API_BASE_URL}/${product.image1?.replace(/^\/+/, "")}`
}
                alt={product.name}
              />

              <div className="tv-navbar-search-result-info">
                <strong>{product.name}</strong>

                <span>
                  Rs : {Number(product.price).toFixed(2)}
                </span>
              </div>

            </button>
          ))
        ) : (
          <div className="tv-navbar-no-results">
            No watches found
          </div>
        )}

      </div>
    )}

  </div>
)}
      </div>

    </header>
  );
}

export default Navbar;